import React, {useMemo, useCallback} from 'react';
import Dropzone, {useDropzone} from 'react-dropzone';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  cursor: 'pointer',
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

function StyledDropzone({ onFilesAdded, singleFile, uploading, disabled }) {
  const onDrop = useCallback(acceptedFiles => {
    onFilesAdded(acceptedFiles);
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    disabled: disabled || false,
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {}),
  }), [
    isDragActive,
    isDragReject,
    isDragAccept,
  ]);

  return (
    <div className="container">
      <div
        {...getRootProps({
          style: {
            ...style,
            cursor: disabled ? 'not-allowed' : 'pointer',
          },
        })}
      >
        <input
          {...getInputProps()}
        />
        <p>
          {uploading ? 'Uploading...' :
            singleFile ? 'Drop file here, or click to select a file.' : 'Drop files here, or click to select files.'
          }
        </p>
      </div>
    </div>
  );
}

export default StyledDropzone;
